//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { IAttachmentDisplayItem } from './IAttachmentDisplayItem';
import { AttachmentBehaviour } from './Enums';

export class CashAttachmentDisplayItem extends ItemBase implements IAttachmentDisplayItem {
    ID: string | null = null;
    CashID: string | null = null;
    Filename: string | null = null;
    FileSize: number = 0;
    ViewURL: string | null = null;
    DownloadURL: string | null = null;
    AttachmentBehaviour: AttachmentBehaviour = AttachmentBehaviour.Image;

    constructor(initializer?: Partial<CashAttachmentDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CashAttachmentDisplayItem";
}
